import FilterRuleEdit from './FilterRuleEdit'
import ListRuleEdit from './ListRuleEdit'
import { isWrapper, RuleEditProps } from './RuleHelpers'
import WrapperRuleEdit from './WrapperRuleEdit'

export default function RuleEdit({ rule, setRule, ...props }: RuleEditProps) {
    if (isWrapper(rule)) {
        return (
            <WrapperRuleEdit rule={rule} setRule={setRule} {...props} />
        )
    }

    if (rule.type === 'list') {
        return (
            <ListRuleEdit rule={rule} setRule={setRule} {...props} />
        )
    }

    return (
        <FilterRuleEdit rule={rule} setRule={setRule} {...props} />
    )
}
